import { ToggleBtn } from '../ProgramSetup.styled';

interface Props {
  on: boolean;
  onChange: (value: boolean) => void;
  disabled?: boolean;
  label?: string;
}

// Backs `daily_schedule.{day}.automation_enabled` — confirmed live on staging.
export const AutomationToggle = ({ on, onChange, disabled, label }: Props) => (
  <ToggleBtn
    type="button"
    role="switch"
    aria-checked={on}
    aria-label={label || 'Enable Automation'}
    $on={on}
    disabled={disabled}
    onClick={() => onChange(!on)}
  />
);
